import { render, staticRenderFns } from "./CustomersFilters.vue?vue&type=template&id=2ee36020&"
import script from "./CustomersFilters.vue?vue&type=script&lang=js&"
export * from "./CustomersFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports